// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1Rr4t","inputDescription":"styles_inputDescription__2tqWd"};